import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DeploymentPollerService } from './services/deployment-poller.service';

@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    providers: [],
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet]
})
export class AppComponent {
  title = 'walletron-pages';

  constructor() {
    inject(DeploymentPollerService).start();
  }
}
